import type { ContactUsConfig, SharePlatformsConfig } from "types";

export const PROJECT_NAME_COOKIE_KEY = "projectName";
export const PROJECT_HOSTNAME_COOKIE_KEY = "hostname";

export const CONTACT_US_METHODS = ["email", "phone"] as const;

export const POLICY_FLAG_LANGUAGES = [
  "ita",
  "eng",
  "deu",
  "fra",
  "esp",
] as const;

export const CONTACT_US_CONFIG: ContactUsConfig = {
  phone: {
    iconName: "phone",
    link: (phone) => `tel:${phone}`,
  },
  email: {
    iconName: "mail",
    link: (email) => `mailto:${email}`,
  },
};

export const SHARE_PLATFORMS_METHODS = [
  "copy",
  "email",
  "whatsapp",
  "facebook",
] as const;

export const SHARE_PLATFORMS_CONFIG: SharePlatformsConfig = {
  copy: { iconName: "clipboard-copy", link: null },
  email: {
    iconName: "mail",
    link: () => "mailto:",
  },
  whatsapp: {
    iconName: "whatsapp",
    link: (text, isMobile = true) =>
      isMobile
        ? `whatsapp://send?text=${text}`
        : `https://web.whatsapp.com://send?text=${text}`,
    "data-action": "share/whatsapp/share",
  },
  facebook: {
    iconName: "facebook",
    link: (text) => `https://www.facebook.com/sharer/sharer.php?u=${text}`,
  },
};

export const DO_LOGOUT_COOKIE = "doLogout";
